import { useMutation, useQuery } from '@apollo/client'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { Button, CardBox, Link, NotificationDialog, Stack, Text } from '../../components'
import { mutations, queries } from '../../graphql'

export function ManageGivingFundDeletion() {
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [successOpen, setSuccessOpen] = useState(false)
  const { fundId: routeFundId } = useParams()

  const { data: { me } = {} } = useQuery(queries.user.me, { fetchPolicy: 'cache-only' })

  const fundProfileId = (() => {
    const profiles = me?.fundProfiles || []
    if (routeFundId) {
      const fund = (me?.funds || []).find((f) => String(f.id) === String(routeFundId))
      return profiles.find((p) => p.fundId === fund?.id)?.id
    }
    return profiles.find((p) => p.fundType === 'donor' && !p.closed)?.id
  })()

  const [closePortal, { loading }] = useMutation(mutations.user.closeMyPortal)

  const handleConfirm = async () => {
    try {
      await closePortal({ variables: { fundProfileId } })
      setConfirmOpen(false)
      setSuccessOpen(true)
    } catch (err) {
      console.error('Error closing giving fund:', err)
      setConfirmOpen(false)
    }
  }

  const handleSuccess = () => {
    setSuccessOpen(false)
    window.location.href = '/logout'
  }

  return (
    <Stack>
      <CardBox>
        <Text.H4>Delete Giving Fund</Text.H4>
        <br />
        <Stack>
          <Text.Body>
            We&apos;re sorry to see you go! Deleting your Giving Fund will immediately delete your giving fund and all
            associated fund data.
          </Text.Body>
          <Text.Body>If you&apos;re sure, please confirm by clicking the button below.</Text.Body>
          <Button onClick={() => setConfirmOpen(true)} color="error" disabled={!fundProfileId}>
            Delete Giving Fund
          </Button>
          <br />
          <br />
          <Text.Body>
            Need help? Contact us at{' '}
            <Link href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}>{process.env.REACT_APP_SUPPORT_EMAIL}</Link>{' '}
            for assistance.
          </Text.Body>
        </Stack>
        <br />

        <NotificationDialog
          open={confirmOpen}
          onClose={() => setConfirmOpen(false)}
          type="alert"
          title="Delete Giving Fund"
          message={
            <>
              Are you sure you want to delete your Giving Fund? This will immediately delete your giving fund and all
              associated fund data.
              <br />
              <br />
              <Text.H7>
                If you have any questions, please contact us at {process.env.REACT_APP_SUPPORT_EMAIL} before proceeding.
              </Text.H7>
            </>
          }
          actions={[
            { label: 'Cancel', onClick: () => setConfirmOpen(false) },
            { label: loading ? 'Deleting...' : 'Delete Giving Fund', onClick: handleConfirm, disabled: loading },
          ]}
        />

        <NotificationDialog
          open={successOpen}
          onClose={handleSuccess}
          type="success"
          title="Giving Fund Deleted"
          message="Your Giving Fund has been deleted immediately."
          actions={[{ label: 'OK', onClick: handleSuccess }]}
        />
      </CardBox>
    </Stack>
  )
}
